var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[(_vm.scrollY > 0)?_c('div',{staticClass:"return-top",on:{"click":_vm.route}},[_c('i',{staticClass:"iconfont icon-down"})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }